import {Comparator} from "./comparator.interface";
import {comparator} from "../decorators/comparator.decorator";
import {injectable} from "tsyringe";
import {ObjectHelper} from "../helpers/object.helper";

@comparator(Object)
@injectable()
export class ObjectComparator implements Comparator<Object> {

    isEqualTo(value1: Object | null, value2: Object | null): boolean {
        return ObjectHelper.deepEqual(value1, value2);
    }

}